module.exports = __webpack_public_path__ + "static/assets/pin.bbb83361.svg";